module.exports = __webpack_public_path__ + "static/media/cosplay8.f706ff96.jpg";